import { Component, ElementRef, EventEmitter, input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { UsersService } from 'src/app/services/users.service';
import { OrganizationsService } from 'src/app/services/organizations.service';
import { Organization } from 'src/app/models/organization';
import { Subscription } from 'rxjs';
import { ThemesService } from 'src/app/services/themes.service';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { TokenStorage } from 'src/app/core/token-storage';
import { DomainSettings } from 'src/app/models/domain-settings';
import { AppsSettings } from 'src/app/models/apps-settings';
import { SettingsService } from 'src/app/services/settings.service';
import { ExternalsParametersService } from 'src/app/services/externals-parameters.service';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AboutComponent } from '../../dialogs/about/about.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatFormFieldModule, MatLabel, MatSuffix } from '@angular/material/form-field';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIconButton, MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { MatToolbar } from '@angular/material/toolbar';
import { EnumReasonResetPassword } from 'src/app/models/enum-reason-reset-password';
import { EnumModeResetPassword } from 'src/app/models/enum-mode-reset-password';
import { ToastrService } from 'ngx-toastr';
import { SecurityPolicyService } from 'src/app/services/security-policy-service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-nav-top-bar',
    templateUrl: './nav-top-bar.component.html',
    styleUrls: ['./nav-top-bar.component.css'],
    imports: [
        MatToolbar,
        MatIconButton,
        MatMenuTrigger,
        MatIcon,
        MatMenu,
        MatFormFieldModule,
        MatMenuItem,
        NgClass,
        ReactiveFormsModule,
        FaIconComponent,
        MatLabel,
        MatInput,
        MatAutocompleteTrigger,
        MatSuffix,
        MatAutocomplete,
        MatOption,
        MatTooltip,
        TranslateModule,
    ],
})
export class NavTopBarComponent implements OnInit, OnDestroy {
    public faFilter = faFilter;

    aboutDialog: MatDialogRef<AboutComponent>;

    @Output() showMenuEmitter = new EventEmitter<boolean>();

    showTopbarConnectedUser = input(true);

    showMenu = true;
    showOrganizationResearch = true;
    externalApplicationTitle: string;
    currentUser: User;
    currentOrganization: Organization;
    isDarkMode: boolean;

    currentUserChange: Subscription;

    treeData: any[];
    organizationSelected: string = '';
    organizationIdSelected: string;
    isEditable = false;

    searchControl: UntypedFormGroup;

    @ViewChild('search', { static: false }) input: ElementRef;

    organizationsList: Organization[];
    organizationsFilter: Organization[] = [];

    currentOrganizationChange: Subscription;

    private externalParametersChange: Subscription;

    domainSettings: DomainSettings;
    cesarApplications: AppsSettings[] = [];

    private OFFICE_DOMAIN_PROPERTY: string = 'ms-domain';

    constructor(
        private authenticationService: AuthenticationService,
        private userService: UsersService,
        private organizationsService: OrganizationsService,
        private dialog: MatDialog,
        private router: Router,
        private translate: TranslateService,
        private settingsService: SettingsService,
        private themesService: ThemesService,
        private formBuilder: UntypedFormBuilder,
        private http: HttpClient,
        private tokenStorage: TokenStorage,
        private externalsParametersService: ExternalsParametersService,
        private toastr: ToastrService,
        private securityPolicyService: SecurityPolicyService,
        private spinner: NgxSpinnerService
    ) {
        this.currentUserChange = userService.currentUserChange$.subscribe((user) => {
            this.currentUser = user;
        });

        settingsService.getDomainSetting().subscribe((result) => {
            this.domainSettings = result;

            for (const [app, settings] of Object.entries(this.domainSettings.apps)) {
                let jsonSettings = JSON.stringify(settings);
                this.cesarApplications.push(JSON.parse(jsonSettings));
            }
        });
    }

    ngOnInit() {
        this.organizationSelected = this.organizationsService.getCurrentOrganization() ? this.organizationsService.getCurrentOrganization().display : '';

        this.themesService.currentTheme$.subscribe((theme) => {
            this.isDarkMode = theme.includes('dark') ? true : false;
        });

        this.searchControl = this.formBuilder.group({
            organizationControl: [''],
            organization: [this.currentOrganization?.display],
        });

        this.searchControl.get('organizationControl').valueChanges.subscribe((value) => {
            value = typeof value === 'string' ? value : value ? value.display : '';
            this.searchOrganization(value);
        });

        this.currentOrganizationChange = this.organizationsService.currentOrganizationChange$.subscribe((o) => {
            this.currentOrganization = o;

            if (this.searchControl && this.currentOrganization) {
                this.searchControl.get('organization').setValue(this.currentOrganization.display);
            }
        });

        // S'il y a des paramètres externes, la recherche d'organisation n'est pas affiché
        this.externalParametersChange = this.externalsParametersService.externalParametersChange$.subscribe((parameters) => {
            if (parameters) {
                this.showOrganizationResearch = parameters ? false : true;
                this.externalApplicationTitle = parameters.name;
            }
        });
    }

    displayWith(element: any) {
        return element ? element.display : null;
    }

    ngOnDestroy() {
        this.currentUserChange.unsubscribe();
        this.currentOrganizationChange.unsubscribe();
        this.externalParametersChange.unsubscribe();
    }

    onEdit() {
        this.isEditable = true;
        setTimeout(() => {
            this.input.nativeElement.focus();
        }, 100);
    }

    searchOrganization(value: string): void {
        if (value.length > 2) {
            this.organizationsService.getOrganisations(false, `display like '%${value}%'`).subscribe((x) => {
                this.organizationsFilter = x;
            });
        } else {
            this.organizationsFilter.splice(0, this.organizationsFilter.length);
        }
    }

    logout() {
        this.authenticationService.logout(this.currentUser.account);
        this.router.navigate(['/login']);
    }

    menuClick() {
        this.showMenu = !this.showMenu;
        this.showMenuEmitter.emit(this.showMenu);
    }

    frenchLanguage() {
        this.translate.setDefaultLang('fr');
        this.translate.use('fr');
        sessionStorage.setItem('language', 'fr');
    }

    englishLanguage() {
        this.translate.setDefaultLang('en');
        this.translate.use('en');
        sessionStorage.setItem('language', 'en');
    }

    onThemeChange() {
        this.themesService.changeTheme(this.isDarkMode ? 'avm-light-theme' : 'avm-dark-theme');
    }

    focusout() {
        this.searchControl.get('organization').setValue(this.currentOrganization.display);
        this.isEditable = false;
    }

    focus() {
        this.searchControl.get('organizationControl').setValue('');
    }

    selectOrganization(organization: Organization) {
        this.organizationsService.setCurrentOrganization(organization);

        this.router.navigate(['/management/organizations']);
    }

    getUrl(url: string) {
        if (this.currentUser) {
            return `${url}?__access_token__=${this.tokenStorage.getToken()}`;
        } else {
            return `${url}`;
        }
    }

    about() {
        this.aboutDialog = this.dialog.open(AboutComponent, {
            panelClass: 'default-dialog',
        });
    }

    modifyPassword() {
        if (this.currentOrganization.properties.filter((a) => a.name === this.OFFICE_DOMAIN_PROPERTY).length > 0) {
            this.toastr.warning(this.translate.instant('ForgottenPassword.ResetMicrosoftAccountError'));
        } else {
            this.spinner.show();

            let redirectUrl = `${window.location.origin}/changepassword?resetPassword=${this.currentUser.id}`;

            this.securityPolicyService.StartPasswordReset(this.currentUser.id, EnumReasonResetPassword.Modify, EnumModeResetPassword.Mail, redirectUrl, null, false).subscribe({
                next: (x) => {
                    this.spinner.hide();

                    const index = this.currentUser.properties.findIndex((a) => a.name === 'Email');

                    const emailContact = index ? this.currentUser.properties[index].value : this.currentUser.account;

                    this.toastr.success(this.translate.instant('ForgottenPassword.ResetMessage', { email: emailContact }), '', {
                        enableHtml: true,
                    });
                },
                error: (err: unknown) => {
                    this.spinner.hide();
                    const error = err as HttpErrorResponse;

                    if (error.status === 412) {
                        this.toastr.error(this.translate.instant('ForgottenPassword.EmailError'), '', { enableHtml: true });
                    } else {
                        this.toastr.error(this.translate.instant('ForgottenPassword.Error'), '', { enableHtml: true });
                    }
                },
            });
        }
    }
}
